import { Branch } from '../../accounting/branch';

export class Supplier {
  id: number;
  name: string;
  code: string;
  contact_person: string;
  address: string;
  city_id: string;
  phone: string;
  fax: string;
  email: string;
  notes: string;
  branches: Branch[];
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/suppliers/supplier.ts